<template>
  <pt-order-handle class="pt-order-handle__page"></pt-order-handle>
</template>

<script>
import PtOrderHandle from 'cps/lab-order/pt-order-handle/withData'
export default {
  name: 'pt-order-handle__view',
  components: {
    'pt-order-handle': PtOrderHandle
  }
}
</script>
